import React, { Component } from "react";
// import Spinner from "./Spinner/Spinner";
import { Redirect } from "react-router-dom";

// import User from "../services/user.service";
import Flow from "../services/flow.service";
// import Settings from "../services/settings.service";

export default function asyncComponent(importComponent) {
  class AsyncComponent extends Component {
    state = {
      routeTo: null
    };

    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
    }

    async componentDidMount() {

      const { default: component } = await importComponent();
      let path = this.props.location.pathname;

      if (path.length > 1) {
        path = path.substring(1);
      }

      let uis_by_path = Flow.get("uis_by_path");
      let node = uis_by_path[path];
      let allowed = true;
      if (node) {
        allowed = Flow.isUIAllowed(node.id, '4');
        if (allowed) {
          setTimeout(() => {
            this.setState({
              component: component
            });
          }, 100);
        } else {
          Flow.goTo();

          //User.fetchFlowStatus(14);
        }
      } else {
        setTimeout(() => {
          this.setState({
            component: component
          });
        }, 100);
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (
        this.state.routeTo !== nextState.routeTo ||
        this.state.component !== nextState.component
      ) {
        return true;
      }
      return false;
    }

    render() {
      const C = this.state.component;
      let routeTo = null;
      if (this.state.routeTo) {
        routeTo = <Redirect to={this.state.routeTo} key={Date.now()} />;
      } else {
        routeTo = "";
      }
      return C ? (
        <div>
          {routeTo}
          <C {...this.props} />
        </div>
      ) : (
        <div>
          {routeTo}
          {/*<div className="loading-overlay">
            <div className="relative">
              <Spinner />
            </div>
          </div>*/}
        </div>
      );
    }
  }

  return AsyncComponent;
}